import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';

import ActionableComment from '../Comment/ActionableComment';
import Loader from '../Loader/Loader';
import { MainContext } from '../../context/MainContext';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../util/APIDjango';
import api from '../../util/api';
import styles from './CommentList.module.scss';
import { useProfileData } from '../../hooks/useProfileData';

// const mapStateToProps = ({ blocked }) => ({ blockedUsers: blocked.users });

const CommentList = ({ postId, isEnabled }) => {
  const { t } = useTranslation();
  const scrollRef = useRef(null);
  // const { blockedUsers } = useSelector(mapStateToProps);
  const { profileData } = useProfileData();
  const { fetchCommentsForPost, commentsForPost } = useContext(MainContext);
  const [loaded, setLoaded] = useState(false);
  const [loadCount, setLoadCount] = useState(0);
  const commentState = commentsForPost(postId);
  const commentsError = commentState?.error;
  const fetching = commentState?.isFetching || false;
  const postComments = commentState?.comments || [];

  useEffect(() => {
    fetchCommentsForPost(postId);
  }, []);

  useEffect(() => {
    if (loadCount > 0) {
      setLoaded(!fetching);
    }
    if (fetching) {
      setLoadCount(loadCount + 1);
    }
  }, [fetching]);

  useEffect(() => {
    if (loaded) {
      setLoadCount(loadCount + 1);
    }
  }, [loaded]);

  const isBlockedAuthor = uuid => profileData.blockedUsers?.some(user => user.uuid === uuid);

  const renderComment = comment => {
    const isBlocked = isBlockedAuthor(comment?.author?.uuid);

    return (
      <ActionableComment
        key={comment.id}
        isBlocked={isBlocked}
        comment={{ ...comment, created: new Date(comment?.created) }}
      />
    );
  };

  const title = () => {
    if (!isEnabled) {
      return t('noCommentsAllowed.label');
    }
    if (fetching) {
      return t('fetchingComments.label');
    }
    if (postComments.length < 1) {
      return t('noComments.label');
    }
    return t('comments.label');
  };

  return (
    <div>
      <div className={styles.title}>{title()}</div>
      {isEnabled && (
        <Fragment>
          {commentsError ? (
            <div>{commentsError}</div>
          ) : (
            postComments.map(comment => renderComment(comment))
          )}
          {fetching && <Loader />}
          <div ref={scrollRef} />
        </Fragment>
      )}
    </div>
  );
};

export default CommentList;
